export const FEATURE_TOP_MDH_PLACEHOLDER = 'top-mdh-placeholder'; // LMITPDPCOP-1079
export const FEATURE_BULK_PERCENTAGE_EDIT = 'bulk-percentage-edit'; // LMITPDPCOP-1077